// The setup run a tab started, kept in the tab's session so a reload can follow it (folder-analysis.ts).
/** The run a setup sample started, kept across a reload of this tab so the screen can find it again. */
const runKey = (jobId: string) => `paige:setup-run:${jobId}`;
export const rememberRun = (jobId: string, runId: string | null) => {
  try {
    if (runId) sessionStorage.setItem(runKey(jobId), runId);
    else sessionStorage.removeItem(runKey(jobId));
  } catch {
    // A tab that keeps nothing (private mode, a blocked store) still shows the run it started.
  }
};
export const rememberedRun = (jobId: string): string | null => {
  try {
    return sessionStorage.getItem(runKey(jobId));
  } catch {
    return null;
  }
};
